<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="走进中云图" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary reveal" data-reveal="fade-up">
          <div class="summary-head">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
          </div>
          <div class="summary-photo reveal" data-reveal="zoom-in" data-delay="120">
            <img src="../assets/img/jianjietopmin.jpg" alt="公司简介" />
          </div>
          <p class="content reveal" data-reveal="fade-up" data-delay="220">{{ companyIntro }}</p>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <div class="content-course reveal" data-reveal="fade-up">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{courseOne.Content}}</p>
                        <p>{{courseOne.Year}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <div class="content-culture reveal" data-reveal="fade-left">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>{{ cultureSlogan }}</p>
          <span
            v-for="(item, index) in cultureItems"
            :key="index"
            class="reveal"
            data-reveal="fade-up"
            :data-delay="120 + index * 90"
          >{{ item }}</span>
        </div>
        <!-- 公司荣誉 -->
        <div class="content-honor reveal" data-reveal="fade-up">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li
              v-for="(honor,index) in honorList"
              :key="index"
              class="reveal"
              data-reveal="zoom-in"
              :data-delay="index * 80"
            >
              <img
                v-lazy="$img(honor.Img)"
                @click="dialogTableVisible = true ;dialogUrl = $img(honor.Img);dialogTitle= honor.Remark"
              />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>
        <!-- 团队风采 -->
        <div class="content-team reveal" data-reveal="fade-up">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team,index) in teamItem" :key="index">
              <div class="swiper-img" v-lazy:background-image="$img(team.Img)"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div class="content-partner reveal" data-reveal="fade-up">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>PARTNERS</p>
            <ul class="partner-img">
              <li
                v-for="(partner,i) in partnerImg"
                :key="i"
                class="reveal"
                data-reveal="fade-up"
                :data-delay="i * 50"
              >
                <img v-lazy="$img(partner.Img)" alt />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      companyIntro: "",
      cultureSlogan: "务实 · 创新 · 协同 · 精益",
      cultureItems: ["航测遥感", "北斗应用", "无人机研产", "三维地信服务"],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      revealObserver: null
    };
  },
  mounted() {
    this.$http
      .all([
        this.$http.get("Honor"),
        this.$http.get("Enterprise"),
        this.$http.get("Team"),
        this.$http.get("Course"),
        this.$http.get("DataDictionary")
      ])
      .then(
        this.$http.spread(
          (
            responseHonor,
            responseEnterprise,
            responseTeam,
            responseCourse,
            responseDict
          ) => {
            this.honorList = responseHonor.data || [];
            this.partnerImg = responseEnterprise.data || [];
            this.teamItem = responseTeam.data || [];

            const courseData = responseCourse.data || [];
            this.courseList = [];
            var groupCount = Math.ceil(courseData.length / 2);
            for (let i = 0; i < groupCount; i++) {
              let img2 = [];
              for (let j = 0; j < 2; j++) {
                if (courseData.length - 1 >= i * 2 + j) {
                  img2.push(courseData[i * 2 + j]);
                }
              }
              this.courseList.push(img2);
            }

            const dictMap = {};
            (responseDict.data || []).forEach(item => {
              if (item && item.Key) dictMap[item.Key] = item.Content;
            });
            if (dictMap.CompanyIntro) this.companyIntro = dictMap.CompanyIntro;
            if (dictMap.CultureSlogan) this.cultureSlogan = dictMap.CultureSlogan;
            const items = [
              dictMap.CultureItem1,
              dictMap.CultureItem2,
              dictMap.CultureItem3,
              dictMap.CultureItem4
            ].filter(Boolean);
            if (items.length) this.cultureItems = items;

            this.loading = false;
            this.$nextTick(() => this.bindReveal());
          }
        )
      )
      .catch(e => {
        window.console.log(e);
        this.loading = false;
        this.$nextTick(() => this.bindReveal());
      });
  },
  beforeDestroy() {
    if (this.revealObserver) {
      this.revealObserver.disconnect();
      this.revealObserver = null;
    }
  },
  methods: {
    bindReveal() {
      if (this.revealObserver) {
        this.revealObserver.disconnect();
      }
      const nodes = this.$el.querySelectorAll(".reveal");
      if (!nodes.length) return;

      if (!("IntersectionObserver" in window)) {
        nodes.forEach(el => el.classList.add("is-visible"));
        return;
      }

      this.revealObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            const delay = Number(el.getAttribute("data-delay") || 0);
            window.setTimeout(() => {
              el.classList.add("is-visible");
            }, delay);
            this.revealObserver.unobserve(el);
          });
        },
        {
          threshold: 0.18,
          rootMargin: "0px 0px -8% 0px"
        }
      );

      nodes.forEach(el => this.revealObserver.observe(el));
    }
  }
};
</script>

<style lang="scss" scoped>
.go-in {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);
  position: relative;

  .section {
    width: 100%;
    padding-bottom: 40px;

    &-content {
      width: 1240px;
      max-width: calc(100% - 32px);
      margin: -28px auto 0;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
      overflow: hidden;
      position: relative;
      z-index: 1;

      .content-summary {
        padding: 56px 64px 44px;

        .summary-head {
          text-align: center;
          margin-bottom: 28px;

          .title {
            margin: 0;
            font-size: 28px;
            color: #17324a;
            font-weight: 600;
          }

          .eTitle {
            margin: 8px 0 0;
            font-size: 13px;
            letter-spacing: 3px;
            color: #7a93a8;
          }
        }

        .summary-photo {
          width: 100%;
          max-width: 880px;
          height: 360px;
          margin: 0 auto 28px;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 12px 28px rgba(15, 47, 74, 0.12);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }
        }

        .content {
          margin: 0 auto;
          max-width: 880px;
          color: #3d5568;
          font-size: 15px;
          text-indent: 2em;
          line-height: 1.95;
          text-align: justify;
        }
      }

      .content-course {
        padding: 40px 0 30px;

        .course-time {
          width: 1000px;
          max-width: calc(100% - 40px);
          height: 400px;
          margin: 20px auto;

          .swiper-container {
            height: 100%;
          }

          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;

            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }

              .item-bottom-content {
                background: linear-gradient(135deg, #1f6fab, #3aa0d8);
                margin: 20px 12px;
                border-radius: 12px;
                box-shadow: 0 10px 22px rgba(31, 111, 171, 0.25);

                p {
                  color: #fff;
                  text-align: center;
                  padding: 14px;
                  margin: 0;
                  line-height: 1.5;
                }
              }
            }
          }
        }
      }

      .content-culture {
        min-height: 360px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 48px 80px;
        background:
          radial-gradient(circle at right top, rgba(58, 160, 216, 0.2), transparent 40%),
          linear-gradient(135deg, #d7e9f6, #eef6fb);

        h3 {
          margin: 0;
          color: #17324a;
          font-size: 28px;
          font-weight: 600;
        }

        h3 + h3 {
          margin-top: 6px;
          font-size: 13px;
          letter-spacing: 3px;
          color: #7a93a8;
          font-weight: 500;
        }

        p {
          margin: 18px 0 10px;
          color: #1f6fab;
          font-size: 22px;
        }

        span {
          display: block;
          font-weight: 400;
          line-height: 1.8;
          font-size: 16px;
          color: #3d5568;
          padding: 2px 0;
        }
      }

      .content-honor {
        padding: 50px 0 30px;

        .honor-show {
          width: 1040px;
          max-width: calc(100% - 40px);
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 16px;

          li {
            width: 220px;
            height: 300px;
            list-style: none;
            border: 1px solid #e6eef5;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 20px rgba(15, 47, 74, 0.08);
            transition: transform 0.25s ease;

            &:hover {
              transform: translateY(-4px);
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              cursor: pointer;
            }
          }
        }

        > p {
          text-align: center;
          color: #7a93a8;
          margin: 0;
        }
      }

      .content-team {
        padding: 40px 80px 30px;

        .swiper-img {
          height: 360px;
          border-radius: 12px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      .content-partner {
        padding: 40px 0 50px;

        .partner-img {
          width: 980px;
          max-width: calc(100% - 40px);
          margin: 20px auto 0;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 16px;

          li {
            width: 108px;
            height: 108px;
            list-style: none;
            border-radius: 12px;
            overflow: hidden;
            border: 1px solid #e6eef5;
            background: #f8fbfe;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              padding: 8px;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
}

.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #17324a;
    font-weight: 500;
    padding: 6px 0;
    margin: 0;
  }

  h3 {
    font-size: 28px;
    font-weight: 600;
  }

  p {
    font-size: 13px;
    letter-spacing: 3px;
    color: #7a93a8;
  }

  .border {
    border-bottom: 1px solid #c9deee;
    width: 72px;
    margin: 10px auto 0;
  }
}

.order {
  order: -1;
}

.order-top {
  order: 1;
}

.el-divider {
  background-color: #c9deee;
  height: 2px;

  .el-divider__text {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    padding: 0;
    color: #fff;
    background: #3aa0d8;
    border: none;
  }
}

.el-divider-active {
  background-color: #c9deee;
}

.honor-big-img {
  text-align: center;

  .el-dialog__body {
    overflow: hidden;

    img {
      width: 100%;
    }
  }
}

.reveal {
  opacity: 0;
  transform: translate3d(0, 28px, 0);
  transition:
    opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
}

.reveal[data-reveal="fade-left"] {
  transform: translate3d(-36px, 0, 0);
}

.reveal[data-reveal="fade-right"] {
  transform: translate3d(36px, 0, 0);
}

.reveal[data-reveal="zoom-in"] {
  transform: scale(0.92);
}

.reveal.is-visible {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

@media (max-width: 960px) {
  .go-in .section-content .content-summary {
    padding: 36px 24px 28px;
  }

  .go-in .section-content .content-summary .summary-photo {
    height: 240px;
  }

  .go-in .section-content .content-course .course-time {
    height: auto;
    min-height: 320px;
  }

  .go-in .section-content .content-course .course-time .time-show {
    width: 100%;
  }

  .go-in .section-content .content-course .course-time .time-show .time-show-item {
    width: 50%;
  }

  .go-in .section-content .content-culture {
    padding: 36px 28px;
    min-height: 0;
  }

  .go-in .section-content .content-team {
    padding: 28px 20px;
  }

  .go-in .section-content .content-team .swiper-img {
    height: 240px;
  }

  .go-in .section-content .content-honor .honor-show li {
    width: calc(50% - 10px);
    height: 240px;
  }
}

@media (max-width: 640px) {
  .go-in .section-content .content-summary .summary-head .title,
  .top h3 {
    font-size: 22px;
  }

  .go-in .section-content .content-summary .summary-photo {
    height: 180px;
  }

  .go-in .section-content .content-course .course-time .time-show {
    flex-direction: column;
  }

  .go-in .section-content .content-course .course-time .time-show .time-show-item {
    width: 100%;
    height: auto;
  }

  .go-in .section-content .content-course .course-time .time-show .time-show-item .item-top {
    display: none;
  }

  .go-in .section-content .content-course .course-time .time-show .time-show-item .item-bottom {
    height: auto;
  }

  .go-in .section-content .content-culture p {
    font-size: 18px;
  }

  .go-in .section-content .content-honor .honor-show li {
    width: 100%;
    height: 260px;
  }

  .go-in .section-content .content-partner .partner-img li {
    width: 88px;
    height: 88px;
  }
}
</style>
}
</style>
